export default __webpack_public_path__ + "static/media/florayfaunahero.f5f61cff.jpg";